import React, { Suspense } from "react"

const StandalonePackageEmbedContainer = React.lazy(
  () =>
    import(
      "./StandalonePackageEmbedContainer" /* webpackChunkName: "StandalonePackageEmbedContainer" */
    )
)

function LazyStandalonePackageEmbedContainer(props: any) {
  return (
    <Suspense fallback={null}>
      <StandalonePackageEmbedContainer {...props} />
    </Suspense>
  )
}

export default LazyStandalonePackageEmbedContainer
